export type MutationMeta<TData = unknown, TError = unknown, TVars = unknown> = {
  successMessage?: string | ((data: TData, vars: TVars) => string);
  errorMessage?: string | ((err: TError, vars: TVars) => string);
  silentSuccess?: boolean;
  silentError?: boolean;
  silentAll?: boolean;
};

const mutationMetaKey = Symbol('mutationMeta');

// Attaches a per-call toast override to a mutation's variables without adding
// an enumerable field — symbol keys are invisible to JSON.stringify,
// Object.keys/entries and object spread, so this can never leak into a
// request payload sent to the backend.
export function withMeta<
  TVars extends object,
  TData = unknown,
  TError = unknown,
>(variables: TVars, meta: MutationMeta<TData, TError, TVars>): TVars {
  Object.defineProperty(variables, mutationMetaKey, {
    value: meta,
    configurable: true,
  });
  return variables;
}

export function getMeta(variables: unknown): MutationMeta | undefined {
  if (typeof variables !== 'object' || variables === null) return undefined;
  return (variables as Record<symbol, MutationMeta | undefined>)[
    mutationMetaKey
  ];
}
